<div class="flex flex-column gap-3" [class.flex-1]="fill" [class.min-h-0]="fill">

    <!-- Le fil. Son conteneur défile lui-même quand l'hôte lui a donné une
         hauteur (le panneau d'aide) ou quand la conversation remplit son hôte
         (la fenêtre) ; sinon c'est la page qui défile autour de lui. -->
    <div #thread [class]="threadClass" [class.flex-1]="fill" [class.min-h-0]="fill"
        [class.overflow-y-auto]="fill">
        <app-assistant-conversation [messages]="messages" [statusText]="statusText" [showUsage]="false"
            [sessionId]="sessionId" (openDoc)="onOpenDoc($event)" (feedbackChange)="onChangeFeedback($event)"></app-assistant-conversation>
    </div>

    <app-assistant-composer [disabled]="streaming" placeholder="Poser une autre question" severity="help"
        (send)="onSendText($event)"></app-assistant-composer>
</div>
